<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="w-full h-full o-hidden" style="background: #F4F6F7;">
    <div class="h-60 bg-white flex a-center header" v-if="hasPhone===1 || hasPhone===2">
      <div class="m-auto flex a-center" style="width: 1160px">
        <div class="fs-20 bold header-title">老刀号管理系统</div>
        <div class="flex-1"></div>
        <div @click="logout" class="logout-btn">
          退出
        </div>
      </div>
    </div>
    <div class="w-full o-hidden" style="height: calc(100% - 60px)">
      <div class="m-auto h-full flex a-center j-center" style="width: 1160px" v-if="hasPhone===1">
        <div class="bind-phone-card" style="width: 1160px;height: 600px">
          <div class="m-auto" style="width: 390px">
            <div class="card-title">绑定手机号码</div>
            <div class="w-full">
              <div class="form-item flex a-center">
                <div class="label">手机号：</div>
                <div class="flex-1">
                  <Input :key="12" :maxlength="13" placeholder="已认证手机" v-model="phone"/>
                </div>
              </div>
              <div class="form-item flex a-center">
                <div class="label">验证码：</div>
                <div class="flex-1">
                  <Input :key="13" class="input-with-select" placeholder="请输入验证码" v-model="smsCode">
                    <Button :disabled="timeout>0" @click="getLoginTelCodes" slot="append">
                      {{ timeout === 0 ? '获取验证码' : `${timeout}秒后重试` }}
                    </Button>
                  </Input>
                </div>
              </div>
            </div>
            <Button @click="onPhoneBindClick" class="submit-btn" type="primary">确定</Button>
          </div>
        </div>
      </div>
      <div class="m-auto" style="width: 1160px;height: calc(100% - 60px)" v-if="hasPhone===2">
        <div class="user-info-card flex a-center m-t-15" style="height: 88px">
          <img :src="getUserLogo" alt=""
               class="avatar m-l-20">
          <div class="flex-1 flex-column j-center p-l-20 user-details" style="align-items: flex-start;height: 48px">
            <div class="username">{{ getUsername }}</div>
            <div class="phone flex a-center">
              {{ loginPhone || '' }}
            </div>
          </div>
        </div>
        <div class="app-list-card p-h-15 p-t-1 m-t-10 text-left o-y-auto noscroll"
             style="min-height:100px;max-height: calc(100% - 65px)"
             v-if="dataList && dataList.length">
          <ul class="w-full block">
            <li :key="index" class="flex-column j-start a-start m-v-20" v-for="(item,index) in dataList">
              <div class="enterprise-title p-v-10 w-full">
                {{ item.name }} <span class="app-count">（{{ item.appList.length }}）</span>
              </div>
              <div class="app-grid w-full">
                <div :key="indexs" @click="" class="app-item"
                     v-for="(items,indexs) in item.appList">
                  <div class="app-top w-full" style="color: #353535;">
                    <img alt="" class="app-icon" src="../../assets/logo.png">
                    <div class="flex-1">
                      <div class="app-name">{{ items.app.name || '' }}</div>
                    </div>
                  </div>

                  <div class="app-bottom w-full">
                    <div class="status-badge">
                      已开通
                    </div>
                    <span @click="onLoginClick(items)" class="action-btn">登录</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../../config/mixinfile'
import {mapActions, mapMutations} from 'vuex'
import {getLoginAppKey, setLoginAppInfo} from '../../utils/util'

export default {
  name: 'PersonCenter',
  mixins: [mixin.mixin],
  data () {
    return {
      tableHeight: 685,
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      columns: [
        {
          title: '应用名称',
          align: 'center',
          key: 'appName',
          width: 80,
          tooltip: true
        },
        {
          title: '所属企业',
          align: 'center',
          key: 'entName',
          width: 180,
          tooltip: true
        }, {
          title: '老刀码',
          align: 'center',
          key: 'ldqr',
          width: 70,
          slot: 'ldqr',
          tooltip: true,
        }, {
          title: '开通时间',
          align: 'center',
          key: 'time',
          width: 190,
          tooltip: true,
        }, {
          title: '倒计时',
          align: 'center',
          key: 'days',
          width: 100,
          tooltip: true,
        },
        {
          title: ' ',
          align: 'center',
          key: 'extend',
        },
        {
          title: '状态',
          align: 'center',
          width: 80,
          key: 'orderStatus',
          render: (h, params) => {
            params.row.orderStatus = 1
            let color = params.row.orderStatus === 1
                ? '#ED0202'
                : params.row.orderStatus === 2
                    ? '#3B80FF'
                    : params.row.orderStatus === 3
                        ? '#C3C3C3'
                        : params.row.orderStatus === 6
                            ? '#999999'
                            : params.row.orderStatus === 7
                                ? '#ED0202'
                                : params.row.orderStatus === 5
                                    ? '#388E3C'
                                    : params.row.orderStatus === 4
                                        ? '#FF9900'
                                        : ''
            let background = color ? (color + 10) : '#fff'
            return h('div', {
              class: {
                'flex-row': true,
                'j-center': true
              }
            }, [h('div', {
                  style: {
                    color: color,
                    background: background,
                    padding: '5px 0px',
                    borderRadius: '14px',
                    width: '70px',
                    textAlign: 'center',
                    fontSize: '12px'
                  },
                },
                '已开通'
            )])
          },
        },
        {
          title: '操作',
          align: 'center',
          width: 150,
          slot: 'operation',
        },
      ],
      dataList: [],
      hasPhone: 0,

      wxName: '',
      wxIcon: '',
      wxGender: '',

      phone: '',
      smsCode: '',

      timeout: 0,
      wxOpenId: '',
      wxUnionId: '',
      loginName: '',
      loginLogo: '',
      loginPhone: '',
    }
  },
  computed: {
    getUsername () {
      let text = '老刀用户'
      if (this.loginName) {
        text = this.loginName
      }
      return text
    },
    getUserLogo () {
      if (this.loginLogo) {
        return this.loginLogo
      }
      return require('../../assets/logo.png')
    },
  },
  watch: {
    '$route.query': {
      handler (newValue, oldValue) {
        if (newValue && newValue.code) {
          if (newValue.state) {
            let state = decodeURI(newValue.state)
            if (state.indexOf('www.cfc99.com') !== -1) {
              this.getPersonLoginInfo(newValue.code)
            } else {
              console.log('location', location)
              const item = this.$router.resolve({
                path: '/personcenter',
                query: {
                  code: newValue.code
                }
              })
              console.log('item', item)
              let {href} = item
              console.log('location', state + href)
              window.open(state + href, '_self')
            }
          } else {
            this.getPersonLoginInfo(newValue.code)
          }
        } else if (newValue && newValue.type && parseInt(newValue.type) === 1) {    //无企业或者多企业,切换企业逻辑
          this.getUserInfos()
          this.hasPhone = 2
        }
      },
      immediate: true
    },
    phone (newValue, oldValue) {
      if (newValue.length > oldValue.length) {
        if (newValue.replace(/-/g, '').length < 3) {
          this.phone = newValue.replace(/-/g, '')
        } else if (newValue.replace(/-/g, '').length >= 3 && newValue.replace(/-/g, '').length < 7) {
          this.phone = newValue.replace(/-/g, '').replace(/(\d{3})/, '$1-')
        } else if (newValue.replace(/-/g, '').length >= 7) {
          this.phone = newValue.replace(/-/g, '').replace(/(\d{3})(\d{4})/, '$1-$2-')
        }
      } else {
        this.phone = this.phone.trim()
      }
    },
  },
  mounted () {
    this.init()
  },
  activated () {
    this.setTableHeight()
  },
  methods: {
    init () {
      this.setTableHeight()
    },
    setTableHeight () {
      this.tableHeight = window.innerHeight - 250
      window.onresize = () => {
        this.tableHeight = window.innerHeight - 250
      }
    },
    async getPersonLoginInfo (code) {
      let params = {
        code: code
      }
      let result = await this.getPersonLoginInfoByCode(params)
      if (result.code === 0) {
        let dataInfo = result.data
        console.log('getPersonLoginInfoByCode', result)
        if (dataInfo.token) {
          this.setLoginToken(dataInfo.token)
          this.$router.replace({
            path: '/personcenter',
            query: {
              type: 1
            }
          })
        } else {
          this.wxName = dataInfo.name || ''
          this.wxIcon = dataInfo.icon || ''
          this.wxGender = dataInfo.gender || 0
          this.wxOpenId = dataInfo.wxOpenId || ''
          this.wxUnionId = dataInfo.unionId || ''
          this.hasPhone = 1
        }
      } else {
        this.$router.replace('/login')
      }
    },
    async getUserInfos () {
      let result = await this.getUserInfo()
      this.loginName = result.name || ''
      this.loginLogo = result.logo || ''
      this.loginPhone = result.phone || ''
      this.getRoleEntLists()
    },

    getRoleEntLists () {
      let param = {
        token: this.$store.state.user.token
      }
      this.getRoleEntList(param).then(res => {
        if (res.code === 0) {
          this.dataList = res.data.map(ress => {
            let tenant = ress.tenant
            return {
              appList: ress.appList,
              ...tenant
            }
          })
        }
      })
    },

    getappStatus (items) {
      if (items.appStatus !== 0) {
        return items.appStatusMsg || ''
      }
      return ''
    },

    /**
     * 获取列表数据
     */
    getDataLists () {
      let params = {
        pageNum: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize
      }
      if (this.searchText) {
        params.name = this.searchText
      }

      //......... 数据请求
    },
    onPageChange (e) {
      this.tablePage.currentPage = e
      this.getDataLists()
    },
    onPageSizeChange (e) {
      this.tablePage.pageSize = e
      if (this.tablePage.currentPage === 1) {
        this.getDataLists()
      }
    },
    onLoginClick (items) {
      if (items.appStatus === 1) {
        return this.$Message.info(items.appStatusMsg)
      } else if (items.appStatus !== 0) {
        return
      }
      let params = {
        entId: items.entPlat.entId,
        appKey: items.app.appKey
      }
      this.setDefaultLoginInfo(params).then(res => {
        if (res.code === 0) {
          let currectKey = getLoginAppKey()
          let obj = {
            appKey: items.app.appKey || '',
            pathEnt: '',
            entId: items.entPlat.entId || 0,
            apptitle: items.app.name || ''
          }
          setLoginAppInfo(obj)
          this.getUserInfo().then(() => {
            let tagNavList = this.$store.state.app.tagNavList
            if (tagNavList && currectKey !== items.app.appKey) {
              let res = tagNavList.filter(item => item.name === this.$config.homeName)
              if (res) {
                this.setTagNavList(res)
              }
            }
            this.$router.replace('/')
          }, err => {
            if (err) {
              this.$Message.info(err)
            }
          })
        }
      })
    },
    logout () {
      this.$store.dispatch('handleLogOut')
      this.$router.replace('/login')
    },
    getLoginTelCodes () {
      let phone = this.phone.replace(/-/g, '')
      if (phone.length < 1) {
        this.$Message.info('请输入手机号码')
        return
      }
      let params = {
        phone: phone,
      }
      this.getBindPhoneCode(params).then((res) => {
        if (res.code === 0) {
          if (res.data && res.data.code) {
            this.smsCode = res.data.code
          }
          let seconds = 60
          let self = this
          self.time = setInterval(() => {
            --seconds
            self.timeout = seconds
            if (seconds <= 0) {
              clearInterval(self.time)
            }
          }, 1000)
        } else {
          this.$Message.info(res.msg)
        }
      })
    },
    onPhoneBindClick () {
      let phone = this.phone.replace(/-/g, '')
      if (phone.length < 1) {
        this.$Message.info('请输入手机号码')
        return
      }
      if (!this.smsCode) {
        return this.$Message.info('请输入验证码')
      }
      if (phone && this.smsCode) {
        let params = {
          name: this.wxName,
          phone: phone,
          icon: this.wxIcon,
          gender: this.wxGender,
          smsCode: this.smsCode,
          wxOpenId: this.wxOpenId,
          wxUnionId: this.wxUnionId
        }
        this.wxBindPhone(params).then(res => {
          if (res.code === 0) {
            let token = res.data.token
            this.setLoginToken(token)
            this.$router.replace({
              path: '/personcenter',
              query: {
                type: 1
              }
            })
          } else {
            if (res.msg) {
              this.$Message.info(res.msg)
            }
          }
        })
      }

    },
    ...mapMutations([
      'setBreadCrumb',
      'setTagNavList',
      'addTag',
      'setLocal',
      'setHomeRoute',
      'closeTag'
    ]),
    ...mapActions([
      'getPersonLoginInfoByCode',
      'getUserInfo',
      'getBindPhoneCode',
      'wxBindPhone',
      'setLoginToken',
      'getRoleEntList',
      'setDefaultLoginInfo'
    ])
  }
}
</script>

<style lang="scss" scoped>
.w-full {
  width: 100%;
}

.h-full {
  height: 100%;
}

.o-hidden {
  overflow: hidden;
}

.h-60 {
  height: 60px;
}

.bg-white {
  background: #fff;
}

.flex {
  display: flex;
}

.a-center {
  align-items: center;
}

.j-center {
  justify-content: center;
}

.m-auto {
  margin: auto;
}

.fs-20 {
  font-size: 20px;
}

.bold {
  font-weight: bold;
}

.flex-1 {
  flex: 1;
}

.text-primary {
  color: #3B80FF;
  cursor: pointer;
  user-select: none;
}

.header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;

  .header-title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 1px;
  }

  .logout-btn {
    padding: 6px 20px;
    border-radius: 4px;
    background: #3B80FF;
    color: #fff;
    font-weight: bold;
    font-size: 14px;
    transition: all 0.3s ease;

    &:hover {
      background: #2b6ee8;
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(59, 128, 255, 0.4);
    }
  }
}

.bind-phone-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 40px;

  .card-title {
    font-size: 22px;
    font-weight: 600;
    color: #333;
    text-align: center;
    margin-bottom: 40px;
  }

  .form-item {
    margin-bottom: 24px;

    .label {
      width: 70px;
      font-size: 14px;
      color: #666;
      flex-shrink: 0;
    }

    .input-with-select {
      :deep(.ivu-input) {
        border-radius: 4px 0 0 4px;
      }

      :deep(.ivu-input-group-append) {
        background: #3B80FF;
        border-color: #3B80FF;
        color: #fff;
        border-radius: 0 4px 4px 0;

        &:hover {
          background: #2b6ee8;
        }

        &[disabled] {
          background: #ccc;
          border-color: #ccc;
        }
      }
    }
  }

  .submit-btn {
    width: 100%;
    height: 44px;
    font-size: 16px;
    background: #3B80FF;
    border-color: #3B80FF;
    border-radius: 6px;
    margin-top: 30px;

    &:hover {
      background: #2b6ee8;
      border-color: #2b6ee8;
    }
  }
}

.user-info-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #f0f0f0;
  flex-shrink: 0;
}

.user-details {
  .username {
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }

  .phone {
    font-size: 14px;
    color: #999;
    margin-top: 4px;
  }
}

.app-list-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  margin-top: 16px;
  padding: 20px;

  .enterprise-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid #f0f0f0;

    .app-count {
      font-size: 14px;
      color: #999;
      font-weight: normal;
    }
  }

  .app-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;

    .app-item {
      background: #fff;
      border-radius: 10px;
      border: 1px solid #ebeef5;
      overflow: hidden;
      transition: all 0.3s ease;
      cursor: pointer;

      &:hover {
        box-shadow: 0 4px 20px rgba(59, 128, 255, 0.15);
        transform: translateY(-2px);
      }

      .app-top {
        display: flex;
        align-items: center;
        padding: 16px;
        min-height: 70px;

        .app-icon {
          width: 44px;
          height: 44px;
          border-radius: 10px;
          margin-right: 12px;
        }

        .app-name {
          font-size: 15px;
          font-weight: 600;
          color: #333;
        }
      }

      .app-bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 16px;
        background: #f8f9fb;
        border-top: 1px solid #ebeef5;

        .status-badge {
          padding: 4px 12px;
          border-radius: 4px;
          font-size: 12px;
          background: #E8F5E9;
          color: #4CAF50;
        }

        .action-btn {
          font-size: 14px;
          color: #3B80FF;
          padding: 4px 12px;
          border-radius: 4px;
          transition: all 0.2s;

          &:hover {
            background: rgba(59, 128, 255, 0.1);
          }
        }
      }
    }
  }
}

.m-t-15 {
  margin-top: 15px;
}

.m-l-20 {
  margin-left: 20px;
}

.p-l-20 {
  padding-left: 20px;
}

.p-h-15 {
  padding-left: 15px;
  padding-right: 15px;
}

.p-t-1 {
  padding-top: 1px;
}

.m-t-10 {
  margin-top: 10px;
}

.m-v-20 {
  margin-top: 20px;
  margin-bottom: 20px;
}

.m-t-5 {
  margin-top: 5px;
}

.o-y-auto {
  overflow-y: auto;
}

.noscroll::-webkit-scrollbar {
  width: 6px;
}

.noscroll::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 3px;
}

.noscroll::-webkit-scrollbar-track {
  background: transparent;
}
</style>
